import React, { useRef, useState, } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { titleType } from "@/types/ScmEnums"
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottom";
import { AddGoodsModal } from "./AddGoodsModal";
import { MaterialHistoryModel } from "./materialHistoryModel"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const PurchaseRoDetails = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const titleType = {
        add: Locale["Add"],
        edit: Locale["Edit"],
        look: Locale["View"],
    }
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const purchaseRoDetails = useRef<IYhFormRef>();
    return (
        <>
            <YhPageHeader title={`${titleType[detailsInfo.mode]}${'  '}${Locale["Purchase Return Doc"]}`} />
            <TopButs {...detailsInfo} purchasePoDetails={purchaseRoDetails} />
            <FormBox {...detailsInfo} purchasePoDetails={purchaseRoDetails} />
            <TableBox {...detailsInfo} purchasePoDetails={purchaseRoDetails} />
            <FixedBottom {...detailsInfo} />
            <AddGoodsModal {...detailsInfo} />
            <MaterialHistoryModel {...detailsInfo} />

        </>
    )
}